import { render } from "./UnreadMessagesCard.vue?vue&type=template&id=ff0f9564&scoped=true"
import script from "./UnreadMessagesCard.vue?vue&type=script&lang=js"
export * from "./UnreadMessagesCard.vue?vue&type=script&lang=js"

import "./UnreadMessagesCard.vue?vue&type=style&index=0&id=ff0f9564&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0f9564"]])

export default __exports__